<template>
  <div class="clouds">
    <div class="left-cloud">
      <side-cloud></side-cloud>
    </div>
    <div class="left-cloud-faded">
      <side-cloud></side-cloud>
    </div>
    <div class="right-cloud">
      <side-cloud></side-cloud>
    </div>
    <div class="right-cloud-faded">
      <side-cloud></side-cloud>
    </div>
    <div class="mobile-cloud">
      <side-cloud></side-cloud>
    </div>
    <div class="mobile-cloud-faded">
      <side-cloud></side-cloud>
    </div>
    <div class="cloud-fade"></div>
  </div>
</template>

<style lang="scss">
  .clouds {
    height: 100%;
    width: 100%;
    position: absolute;
    bottom: 0;
    display: flex;
    overflow: hidden;

    @media(min-width: 900px) and (max-width: 1200px) {
      height: 100%;
    }
  }

  .left-cloud {
    z-index: 5;
    position: absolute;
    top: 10%;
    left: -19%;
    transform-origin: top left;
    transform: rotate(55deg) scale(0.8);

    @media(max-width: 500px) {
      top: 30%;
      left: -40%;
      transform: rotate(45deg) scale(0.6);
    }

    @media(min-width: 501px) and (max-width: 600px) {
      top: 15%;
      left: -40%;
      transform: rotate(45deg) scale(0.7);
    }

    @media(min-width: 601px) and (max-width: 900px) {
      top: 12%;
      left: -42%;
      transform: rotate(45deg) scale(0.8);
    }

    @media(min-width: 901px) and (max-width: 1200px) {
      top: 8%;
      left: -20%;
    }
  }

  .left-cloud-faded {
    z-index: 4;
    position: absolute;
    top: 22%;
    left: -25%;
    transform-origin: top left;
    transform: rotate(42deg) scale(0.7);
    opacity: 0.5;

    @media(max-width: 500px) {
      top: 30%;
      left: -30%;
      transform: rotate(45deg) scale(0.6);
    }

    @media(min-width: 501px) and (max-width: 600px) {
      top: 15%;
      left: -30%;
      transform: rotate(45deg) scale(0.7);
    }

    @media(min-width: 601px) and (max-width: 900px) {
      top: 10%;
      left: -40%;
      transform: scale(0.5) rotate(45deg);
    }

    @media(min-width: 901px) and (max-width: 1200px) {
      top: 8%;
      left: -36%;
    }
  }

  .right-cloud {
    z-index: 5;
    position: absolute;
    top: 15%;
    right: -20%;
    transform-origin: top right;
    transform: rotate(-50deg) scale(0.85);
    display: flex;
    flex-direction: row-reverse;

    @media(max-width: 500px) {
      top: 30%;
      right: -40%;
      transform: rotate(-45deg) scale(0.6);
    }

    @media(min-width: 501px) and (max-width: 600px) {
      top: 30%;
      right: -40%;
      transform: rotate(-30deg) scale(0.5);
    }

    @media(min-width: 601px) and (max-width: 900px) {
      top: 12%;
      right: -42%;
      transform: rotate(-45deg) scale(0.8);
    }

    @media(min-width: 901px) and (max-width: 1200px) {
      top: 8%;
      right: -20%;
    }
  }

  .right-cloud-faded {
    z-index: 4;
    position: absolute;
    top: 20%;
    right: -17%;
    transform-origin: top right;
    transform: rotate(-50deg) scale(0.85);
    display: flex;
    flex-direction: row-reverse;
    opacity: 0.5;

    @media(max-width: 500px) {
      top: 30%;
      right: -30%;
      transform: rotate(-45deg) scale(0.6);
    }

    @media(min-width: 501px) and (max-width: 600px) {
      top: 15%;
      right: -30%;
      transform: rotate(-45deg) scale(0.7);
    }

    @media(min-width: 601px) and (max-width: 900px) {
      top: 10%;
      right: -40%;
      transform: scale(0.5) rotate(-45deg);
    }
    @media(min-width: 901px) and (max-width: 1200px) {
      top: 8%;
      right: -36%;
    }
  }

  .cloud-fade {
    width: 100%;
    height: 20%;
    top: 80%;
    background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1));
    z-index: 99;
    position: absolute;

    @media(max-width: 1200px) {
      display: none;
    }
  }

  .mobile-cloud {
    z-index: 4;
    position: absolute;
    top: 60%;
    right: -10%;
    transform-origin: top right;
    display: flex;
    flex-direction: row-reverse;
    top: 80%;
    transform: scale(0.7);

    @media(max-width: 500px) {
      top: 66%;
      transform: rotate(5deg) scale(0.4);
      z-index: 6;
    }

    @media(min-width: 501px) and (max-width: 900px) {
      top: 68%;
      transform: rotate(0deg) scale(0.5);
      z-index: 6;
    }

    @media(min-width: 900px) and (max-width: 1200px) {
      top: 63%;
      transform: rotate(-3deg) scale(0.7);
      z-index: 7
    }
  }

  .mobile-cloud-faded {
    z-index: 3;
    position: absolute;
    top: 80%;
    right: -55%;
    transform-origin: top right;
    display: flex;
    flex-direction: row-reverse;
    transform: scale(0.6);
    opacity: 0.5;

    @media(max-width: 500px) {
      top: 66%;
    }

    @media(min-width: 501px) and (max-width: 900px) {
      top: 68%;
    }

    @media(min-width: 900px) and (max-width: 1200px) {
      top: 63%;
    }
  }
</style>

<script>
import SideCloud from './SideCloud'

export default {
  components: {
    SideCloud
  }
}
</script>
